<template>
  <VLayout>
    <VFlex xs8>
      <VCard style="height: calc(100vh - 100px)">
        <VLayout justify-space-around row>
          <VFlex xs12>
            <VCardTitle style="font-variant: small-caps">
              <h1>Šifrant partnerjev</h1>
              <v-spacer />
              <v-text-field
                v-model="query"
                label="Išči po davčni št. ali nazivu"
                single-line
                hide-details
              />
              <v-btn color="primary" @click="search"> Išči </v-btn>
              <v-btn
                color="info"
                :disabled="!partners || !partners.length"
                @click="exportDialog = true"
              >
                Izvozi
              </v-btn>
            </VCardTitle>
            <VContainer class="pa-0" fill-height fluid>
              <VLayout fill-height>
                <VFlex xs12>
                  <VDataTable
                    :headers="headers"
                    :items="partners"
                    :pagination.sync="pagination"
                    :rows-per-page-items="[5, 10, 25, 50]"
                    rows-per-page-text="Vrstic na stran"
                    :total-items="totalItems"
                  >
                    <template slot="items" slot-scope="props">
                      <td class="text-xs-center">
                        {{ props.item.name }}
                      </td>
                      <td class="text-xs-center">
                        {{ props.item.country }}
                      </td>
                      <td class="text-xs-center">
                        {{ props.item.vat_id }}
                      </td>
                      <td class="text-xs-center">
                        {{ props.item.email }}
                      </td>
                      <td class="text-xs-center">
                        {{ props.item.scan_email }}
                      </td>
                      <td class="text-xs-center">
                        {{ props.item.external_api }}
                      </td>
                      <td class="text-xs-center">
                        <v-icon v-if="props.item.payment_processing" color="success"> done </v-icon>
                        <v-icon v-else color="red"> clear </v-icon>
                      </td>
                      <td class="text-xs-center">
                        <v-icon v-if="props.item.allow_auto_forward" color="success"> done </v-icon>
                        <v-icon v-else color="red"> clear </v-icon>
                      </td>
                      <td class="text-xs-center">
                        <VTooltip top>
                          <VBtn
                            slot="activator"
                            flat
                            icon
                            color="blue"
                            @click.stop="editWhitelist(props.item)"
                          >
                            <VIcon>book</VIcon>
                          </VBtn>
                          <span>Uredite email whitelista</span>
                        </VTooltip>
                      </td>
                      <td class="text-xs-center">
                        <VTooltip top>
                          <VBtn
                            slot="activator"
                            flat
                            icon
                            color="green"
                            @click.stop="startEditing(props.item)"
                          >
                            <VIcon>edit</VIcon>
                          </VBtn>
                          <span>Uredite pravilo</span>
                        </VTooltip>
                        <VTooltip top>
                          <VBtn
                            slot="activator"
                            flat
                            icon
                            color="red"
                            @click.stop="deletePartner(props.item)"
                          >
                            <VIcon>delete</VIcon>
                          </VBtn>
                          <span>Izbrišite pravilo</span>
                        </VTooltip>
                      </td>
                    </template>
                    <template slot="no-data"> Sorry, nothing to display here :( </template>
                  </VDataTable>
                </VFlex>
              </VLayout>
            </VContainer>
          </VFlex>
        </VLayout>
      </VCard>
    </VFlex>
    <VFlex xs4>
      <VCard style="height: calc(100vh - 100px); overflow-y: scroll">
        <VLayout justify-space-around row>
          <VFlex xs10>
            <VCardTitle style="padding: 10px 0 0 0; font-variant: small-caps">
              <h2>{{ currentActionText }}</h2>
            </VCardTitle>
            <VContainer fluid style="padding: 0 0 0 10px">
              <VLayout fill-height row wrap>
                <VFlex xs12>
                  <VTextField v-model="partnerObject.name" label="Naziv podjetja" type="string" />
                </VFlex>
                <VFlex xs12>
                  <v-autocomplete
                    v-model="partnerObject.country"
                    label="Država"
                    :items="prettyCountryList"
                    persistent-hint
                    item-text="pretty"
                    item-value="iso_code"
                  />
                </VFlex>
                <VFlex xs8>
                  <VTextField v-model="partnerObject.city" label="Mesto" type="string" />
                </VFlex>
                <VFlex xs4>
                  <VTextField
                    class="ml-1"
                    v-model="partnerObject.post_code"
                    label="Poštna št."
                    type="string"
                  />
                </VFlex>
                <VFlex xs12>
                  <VTextField v-model="partnerObject.address" label="Naslov" type="string" />
                </VFlex>
                <VFlex xs12>
                  <VTextField
                    v-model="partnerObject.vat_id"
                    label="Davčna številka"
                    type="string"
                  />
                </VFlex>
                <VFlex xs12>
                  <VTextField v-model="partnerObject.notes" label="Opombe" type="string" />
                </VFlex>
                <VFlex xs12>
                  <VTextField v-model="partnerObject.email" label="Email" type="email" />
                </VFlex>
                <VFlex xs12>
                  <VTextField
                    v-model="partnerObject.scan_email"
                    label="Email za izvoz dokumentov"
                    type="email"
                    hint="Vsi dokumenti (skenirani in prejeti po e-pošti) se namesto v integracijo pošljejo na ta naslov kot eSlog (XML + PDF)."
                    persistent-hint
                    clearable
                    :rules="[(v) => validateEmail(v) || 'Neveljaven email naslov']"
                  />
                </VFlex>
                <VFlex xs12>
                  <v-select
                    v-model="partnerObject.external_api"
                    label="Integracija"
                    :items="externalApiList"
                    clearable
                    persistent-hint
                  />
                </VFlex>
                <VFlex v-if="partnerObject.external_api === 'e-Line'" xs12 class="ml-2">
                  <VTextField
                    v-model="partnerObject.external_api_settings.eline_ftp"
                    label="FTP naslov"
                    type="string"
                  />
                  <VTextField
                    v-model="partnerObject.external_api_settings.eline_url"
                    label="Eline URL"
                    type="text"
                  />
                  <VTextField
                    v-model="partnerObject.external_api_settings.eline_id"
                    label="Eline ID"
                    type="text"
                  />
                </VFlex>
                <VFlex
                  v-if="['OpPIS', 'MojArhiv'].includes(partnerObject.external_api)"
                  xs12
                  class="ml-2"
                >
                  <VTextField
                    v-model="partnerObject.external_api_settings.oppis_partner_db_name"
                    label="Ime baze za partnerje"
                    type="text"
                  />
                </VFlex>
                <VFlex v-if="partnerObject.external_api === 'OpPIS_PANTHEON'" xs12 class="ml-2">
                  <VTextField
                    v-model="partnerObject.external_api_settings.domain_name"
                    label="Ime domene na Pantheonu"
                    type="text"
                  />
                  <VTextField
                    v-model="partnerObject.external_api_settings.workflow_def_key"
                    label="ID poslovnega procesa za račune"
                    type="number"
                  />
                  <VTextField
                    v-model="partnerObject.external_api_settings.bank_statement_workflow_def_key"
                    label="ID poslovnega procesa za bančne izpiske"
                    type="number"
                  />
                  <VTextField
                    v-model="partnerObject.external_api_settings.document_type_mapping.OST"
                    label="Ident za ostalo"
                    type="number"
                  />
                  <VTextField
                    v-model="partnerObject.external_api_settings.document_type_mapping.IRN"
                    label="Ident za izdani račun"
                    type="number"
                  />
                  <VTextField
                    v-model="partnerObject.external_api_settings.document_type_mapping.BNK_STMNT"
                    label="Ident za bančne izpiske"
                    type="number"
                  />
                </VFlex>
                <VFlex v-if="partnerObject.external_api === 'Pantheon'" xs12 class="ml-2">
                  <VTextField
                    v-model="partnerObject.external_api_settings.domain_name"
                    label="Ime domene na Pantheonu"
                    type="text"
                  />
                  <VTextField
                    v-model="partnerObject.external_api_settings.workflow_def_key"
                    label="ID poslovnega procesa za račune"
                    type="number"
                  />
                  <VTextField
                    v-model="partnerObject.external_api_settings.bank_statement_workflow_def_key"
                    label="ID poslovnega procesa za bančne izpiske"
                    type="number"
                  />
                  <VTextField
                    v-model="partnerObject.external_api_settings.document_type_mapping.INV"
                    label="Ident za prejeti račun"
                    type="number"
                  />
                  <VTextField
                    v-model="partnerObject.external_api_settings.document_type_mapping.OST"
                    label="Ident za ostalo"
                    type="number"
                  />
                  <VTextField
                    v-model="partnerObject.external_api_settings.document_type_mapping.IRN"
                    label="Ident za izdani račun"
                    type="number"
                  />
                  <VTextField
                    v-model="partnerObject.external_api_settings.document_type_mapping.BNK_STMNT"
                    label="Ident za bančne izpiske"
                    type="number"
                  />
                </VFlex>
                <VFlex v-if="partnerObject.external_api" xs12>
                  <VBtn
                    color="info"
                    @click="testConnection"
                    :disabled="testConnectionDisabled"
                    class="v-btn--block"
                    :loading="partnerConnectivityTestResultsLoading"
                  >
                    Preveri povezavo do šifranta
                  </VBtn>
                  <v-alert
                    style="word-break: break-all"
                    v-model="partnerConnectivityTestResultsShow"
                    dismissible
                    :color="connectivityAlert[0]"
                    transition="scale-transition"
                  >
                    {{ connectivityAlert[1] }}
                  </v-alert>
                </VFlex>
                <VFlex xs12>
                  <v-checkbox
                    v-model="partnerObject.enable_mail_notification_both_parties_clients"
                    label="Email, ko sta obe Unijini stranki"
                    color="primary"
                  />
                </VFlex>
                <VFlex xs12>
                  <v-checkbox
                    v-model="partnerObject.add_source_id"
                    label="Dodaj SourceID"
                    color="primary"
                    @change="checkAddSourceId($event)"
                  />
                </VFlex>
                <VFlex xs12>
                  <v-checkbox
                    v-model="partnerObject.use_internal_inv_num"
                    label="Uporabi interno št. računa"
                    color="primary"
                    @change="checkUseInternalInvNum($event)"
                  />
                </VFlex>
                <VFlex xs12>
                  <v-checkbox
                    v-model="partnerObject.payment_processing"
                    label="Plačilni promet"
                    color="primary"
                  />
                </VFlex>
                <VFlex xs12>
                  <v-checkbox
                    v-model="partnerObject.vat_subject"
                    label="Davčni zavezanec"
                    color="primary"
                  />
                </VFlex>
                <VFlex xs12>
                  <v-switch
                    v-model="partnerObject.allow_auto_forward"
                    label="Avtomatsko posredovanje"
                    color="primary"
                  />
                </VFlex>
                <VFlex xs12>
                  <VTextField
                    v-model="partnerObject.auto_forward_note"
                    label="Opomba (avtomatsko posredovanje)"
                    type="string"
                    counter="300"
                    maxlength="300"
                  />
                </VFlex>
                <VFlex xs12>
                  <v-select
                    v-model="partnerObject.allowed_document_types"
                    label="Dovoljeni tipi dokumentov"
                    color="primary"
                    :items="documentTypes"
                    multiple
                  />
                </VFlex>
                <v-flex xs12 style="display: flex; justify-content: flex-end">
                  <VBtn v-if="editing" @click.stop="stopEditing"> Prekliči urejanje </VBtn>
                  <VBtn
                    color="primary"
                    :disabled="!validatePartnerFields()"
                    @click="createNewPartner"
                  >
                    Potrdi
                  </VBtn>
                </v-flex>
              </VLayout>
            </VContainer>
            <template>
              <v-dialog v-model="exportDialog" scrollable max-width="25vw">
                <v-card>
                  <v-card-title>
                    <h2>Izberite polja za izvoz</h2>
                  </v-card-title>
                  <v-divider />
                  <v-card-text style="height: 40vh">
                    <template v-for="(header, key) in exportConfig">
                      <v-checkbox
                        :key="key"
                        v-model="header.export"
                        :label="header.exportHeader"
                        color="primary"
                      />
                    </template>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions style="justify-content: right">
                    <v-btn text @click="exportDialog = false"> Zapri </v-btn>
                    <v-btn color="primary" text :loading="exportLoading" @click="exportTableAsCsv">
                      Izvozi {{ partners.length }} vrstic
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </template>
            <template>
              <v-dialog v-model="whitelistDialog" max-width="600px">
                <v-card>
                  <v-card-title>
                    <VCardTitle style="font-variant: small-caps">
                      <h1>Urejanje whiteliste</h1>
                    </VCardTitle>
                  </v-card-title>
                  <v-card-text>
                    <v-form ref="whitelistForm">
                      <v-container fluid>
                        <v-layout wrap>
                          <v-flex xs12>
                            <v-combobox
                              v-model="whitelistForm.primary_contacts"
                              label="Primarni kontakti"
                              multiple
                              chips
                              :rules="[
                                (v) =>
                                  !v ||
                                  (Array.isArray(v) && v.every((email) => validateEmail(email))) ||
                                  'Neveljaven email naslov',
                              ]"
                            />
                          </v-flex>
                          <v-flex xs12>
                            <v-combobox
                              v-model="whitelistForm.allowed_emails"
                              label="Dovoljeni emaili"
                              multiple
                              chips
                              :rules="[
                                (v) =>
                                  !v ||
                                  (Array.isArray(v) && v.every((email) => validateEmail(email))) ||
                                  'Neveljaven email naslov',
                              ]"
                            />
                          </v-flex>
                          <v-flex xs12>
                            <v-checkbox
                              v-model="whitelistForm.no_limits"
                              label="Brez omejitev"
                              color="primary"
                            />
                          </v-flex>
                          <v-flex xs12>
                            <v-textarea v-model="whitelistForm.notes" label="Opombe" rows="3" />
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-form>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn color="grey-lighten-1" text @click="closeWhitelistDialog">
                      Prekliči
                    </v-btn>
                    <v-btn color="primary" @click="saveWhitelist" :loading="whitelistSaving">
                      Shrani
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </template>
          </VFlex>
        </VLayout>
      </VCard>
    </VFlex>
  </VLayout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { convertToCSV, exportFile } from '../helpers/export_data';
import ExportConfig from '../../public/partner_export_fields.json';
import { testPartnerConnectivity } from '@/services/api';
import { emailRegex } from '../helper';
import { cloneDeep } from 'lodash';

export default {
  name: 'Partners',
  data() {
    return {
      headers: [
        {
          text: 'Naziv podjetja',
          value: 'name',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Država',
          value: 'country',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Davčna številka',
          value: 'vat_id',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Email naslov za pošiljanje',
          value: 'email',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Email za izvoz',
          value: 'scan_email',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Integracija',
          value: 'external_api',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Plačilni promet',
          value: 'payment_processing',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Avtomatsko posredovanje',
          value: 'allow_auto_forward',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Email whitelista',
          value: 'email_whitelist',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Akcije',
          align: 'center',
          sortable: false,
        },
      ],
      exportConfig: this._.cloneDeep(ExportConfig),
      exportDialog: false,
      exportLoading: false,
      partnerObject: null,
      emptyPartnerObject: {
        name: '',
        country: '',
        city: '',
        post_code: '',
        address: '',
        vat_id: null,
        email: '',
        scan_email: '',
        external_api: null,
        external_api_settings: {},
        enable_mail_notification_both_parties_clients: false,
        add_source_id: false,
        use_internal_inv_num: false,
        payment_processing: false,
        vat_subject: true,
        notes: '',
        allow_auto_forward: true,
        auto_forward_note: '',
        allowed_document_types: ['INV', 'OST', 'IRN'],
      },
      externalApiList: ['OpPIS', 'e-Line', 'Pantheon', 'MojArhiv', 'OpPIS_PANTHEON'],
      externalApiSettingBackups: {},
      startedEditing: false,
      partnerConnectivityTestResults: {
        successful: false,
        n_results: 0,
        error_msg: '',
      },
      partnerConnectivityTestResultsLoading: false,
      partnerConnectivityTestResultsShow: false,
      editing: false,
      editingActionText: 'Uredi vnos',
      createNewActionText: 'Dodaj vnos',
      currentActionText: 'Dodaj vnos',
      totalItems: 0,
      pagination: {
        page: 1,
        rowsPerPage: 10,
        totalItems: 0,
      },
      previousPage: 1,
      lastKey: {
        current: null,
        previous: null,
      },
      query: '',
      documentTypes: [
        { text: 'Prejeti račun', value: 'INV' },
        { text: 'Ostalo', value: 'OST' },
        { text: 'Izdani račun', value: 'IRN' },
      ],
      whitelistDialog: false,
      whitelistSaving: false,
      currentPartner: null,
      whitelistForm: {
        partner: '',
        primary_contacts: [],
        allowed_emails: [],
        no_limits: true,
        notes: '',
      },
    };
  },
  computed: {
    ...mapGetters({
      partners: 'partners',
      countries: 'countries',
      currentWhitelist: 'currentWhitelist',
    }),
    prettyCountryList() {
      return this.countries.map((obj) => ({ ...obj, pretty: `${obj.iso_code} | ${obj.name}` }));
    },
    connectivityAlert() {
      if (!this.partnerConnectivityTestResults.successful) {
        return ['red', `Povezava ne deluje. ${this.partnerConnectivityTestResults.error_msg}`];
      }
      if (this.partnerConnectivityTestResults.n_results === 0) {
        return ['warning', `Povezave deluje, vendar nismo našli partnerjev`];
      }
      return [
        'success',
        `Povezave deluje, našli smo ${this.partnerConnectivityTestResults.n_results} partnerjev.`,
      ];
    },
    testConnectionDisabled() {
      if (!this.partnerObject || !this.partnerObject.vat_id) {
        return true;
      }
      switch (this.partnerObject.external_api) {
        case 'OpPIS':
        case 'MojArhiv':
          return false;
        case 'Pantheon':
          return !this.partnerObject.external_api_settings.domain_name;
        case 'OpPIS_PANTHEON':
          return !this.partnerObject.external_api_settings.domain_name;
        case 'e-Line':
          const settings = this.partnerObject.external_api_settings;
          return !settings.eline_url || !settings.eline_id;

        default:
          return true;
      }
    },
  },
  watch: {
    pagination: {
      handler() {
        if (this.previousPage < this.pagination.page) {
          this.getPartnersAction({ start_key: this.lastKey.current, query: this.query });
        } else if (this.previousPage > this.pagination.page) {
          const params =
            this.lastKey.previous === null
              ? { start_key: this.lastKey.previous, query: this.query }
              : { query: this.query };
          this.getPartnersAction(params);
        }
        this.previousPage = this.pagination.page;
      },
      deep: true,
    },
    partners: {
      handler() {
        /* Update pagination ability */
        this.lastKey.previous = this.lastKey.current;
        this.lastKey.current = this.partners.last_key;
      },
    },
    'partnerObject.external_api': {
      handler(newVal, oldVal) {
        if (this.startedEditing) {
          this.startedEditing = false;
          oldVal = null;
        }
        // Makes sure settings only for one external api are saved
        // Also handle backups so entered data doesn't get lost upon switching
        const externalApiToBackup = oldVal ? oldVal : newVal;
        this.externalApiSettingBackups[externalApiToBackup] =
          this.partnerObject.external_api_settings;
        this.partnerObject.external_api_settings = {};
        if (this.externalApiSettingBackups[newVal]) {
          this.partnerObject.external_api_settings = this.externalApiSettingBackups[newVal];
        }

        // Pantheon settings are nested, doing the below avoids keyError
        if (
          (newVal === 'Pantheon' || newVal === 'OpPIS_PANTHEON') &&
          !this.partnerObject.external_api_settings.document_type_mapping
        ) {
          this.$set(this.partnerObject.external_api_settings, 'document_type_mapping', {});
        }
      },
    },
  },
  mounted() {
    this.getPartnersAction({});
    this.getCountriesAction({});
  },
  created() {
    this.partnerObject = this._.cloneDeep(this.emptyPartnerObject);
  },
  methods: {
    ...mapActions([
      'refreshCredentials',
      'createPartnerAction',
      'getPartnersAction',
      'getCountriesAction',
      'removePartnerAction',
      'setSnackBarStateAction',
      'editPartnerAction',
      'getWhitelistAction',
      'createWhitelistAction',
      'updateWhitelistAction',
    ]),
    startEditing(Partner) {
      this.partnerObject = this._.cloneDeep(Partner);
      if (!this.partnerObject.external_api_settings) {
        this.partnerObject.external_api_settings = {};
      }

      // Pantheon settings are nested, doing the below avoids keyError
      if (
        (this.partnerObject.external_api === 'Pantheon' ||
          this.partnerObject.external_api === 'OpPIS_PANTHEON') &&
        !this.partnerObject.external_api_settings.document_type_mapping
      ) {
        this.$set(this.partnerObject.external_api_settings, 'document_type_mapping', {});
      }

      this.externalApiSettingBackups = {};
      this.startedEditing = true;
      this.editing = true;
      this.currentActionText = this.editingActionText;
    },
    stopEditing() {
      this.partnerObject = this._.cloneDeep(this.emptyPartnerObject);
      this.editing = false;
      this.currentActionText = this.createNewActionText;
    },
    showSnackbar(successful, msg) {
      const snackbarColor = successful ? 'green' : 'red';
      this.setSnackBarStateAction({
        snackBar: true,
        color: snackbarColor,
        text: msg,
      });
    },
    checkAddSourceId(event) {
      this.partnerObject.add_source_id = event;
      if (!event) {
        this.partnerObject.use_internal_inv_num = false;
      }
    },
    checkUseInternalInvNum(event) {
      this.partnerObject.use_internal_inv_num = event;
      if (event) {
        this.partnerObject.add_source_id = true;
      }
    },
    async createNewPartner() {
      try {
        if (!this.partnerObject.external_api || this.partnerObject.external_api_settings === {}) {
          this.partnerObject.external_api_settings = null;
          this.partnerObject.external_api = null;
        }

        // clearable sets the value to null, backend field is not nullable
        this.partnerObject.scan_email = this.partnerObject.scan_email || '';

        if (this.partnerObject.url) {
          await this.editPartnerAction(this.partnerObject);
          this.showSnackbar(true, 'Povezava je bila uspešno posodobljena.');
          this.stopEditing();
        } else {
          await this.createPartnerAction(this.partnerObject);
          this.showSnackbar(true, 'Dodajanje povezave je bilo uspešno.');
          this.partnerObject = this._.cloneDeep(this.emptyPartnerObject);
        }
      } catch (err) {
        this.setSnackBarStateAction({
          snackBar: true,
          color: 'red',
          text: 'Napaka pri dodajanju nove povezave. Poskusite znova ali pokličite administratorja.',
        });
      }
    },
    deletePartner(partner) {
      try {
        /* Update Vue Store */
        this.removePartnerAction(partner);
        this.showSnackbar(
          true,
          `Uspešno ste izbrisali povezavo za davčno številko: ${partner.vat_id}`
        );
      } catch (err) {
        this.showSnackbar(
          false,
          'Napaka pri brisanju povezave. Poskusite znova ali pokličite administratorja.'
        );
      }
    },
    async search() {
      await this.getPartnersAction({ query: this.query });
    },
    exportTableAsCsv() {
      // We have to provide CSV headers and corresponding keys
      // that will be sent into the convertToCSV function
      const headerMapList = [];
      this.exportConfig.forEach((header) => {
        if (header.export) {
          headerMapList.push({
            headerValue: header.exportHeader,
            objKey: header.key,
            inQuotes: header.inQuotes,
            subFields: header.subFields,
          });
        }
      });
      const csvString = convertToCSV(this.partners, headerMapList, ',', true);
      exportFile(csvString, `partners_${new Date().toJSON().slice(0, 10)}`, '.csv');
      // We aren't really waiting for anything, it just takes
      // time for the browser to show the downloaded file
      this.exportLoading = true;
      setTimeout(() => {
        this.exportLoading = false;
        this.exportDialog = false;
      }, 700);
    },
    validatePartnerFields() {
      if (
        !this.partnerObject ||
        !this.partnerObject.city ||
        !this.partnerObject.vat_id ||
        !this.partnerObject.post_code ||
        !this.partnerObject.address ||
        !(this.partnerObject.email || this.partnerObject.external_api)
      ) {
        return false;
      }

      if (this.partnerObject.scan_email && !this.validateEmail(this.partnerObject.scan_email)) {
        return false;
      }

      const settings = this.partnerObject.external_api_settings;

      switch (this.partnerObject.external_api) {
        case 'Pantheon':
          const mappings = settings.document_type_mapping;
          if (
            !settings.domain_name ||
            !settings.workflow_def_key ||
            !(mappings && this._.size(mappings) === 4)
          ) {
            return false;
          }
          for (const [key, value] of Object.entries(mappings)) {
            if (!value) return false;
          }
          return true;

        case 'e-Line':
          if (settings.eline_id && settings.eline_url && settings.eline_ftp) {
            return true;
          }
          return false;

        case 'OpPIS':
        case 'MojArhiv':
          if (!settings.oppis_partner_db_name) {
            return false;
          }
          return true;
        case 'OpPIS_PANTHEON':
          if (!settings.domain_name) return false;
          const oppisPantheonMappings = settings.document_type_mapping;
          if (
            !settings.workflow_def_key ||
            !(oppisPantheonMappings && this._.size(oppisPantheonMappings) === 3)
          ) {
            return false;
          }
          for (const [key, value] of Object.entries(oppisPantheonMappings)) {
            if (!value) return false;
          }
          return true;
        default:
          return true;
      }
    },
    async testConnection() {
      const params = {
        name: this.partnerObject.name,
        vat_id: this.partnerObject.vat_id,
        external_api: this.partnerObject.external_api,
        external_api_settings: { ...this.partnerObject.external_api_settings },
      };

      this.partnerConnectivityTestResultsLoading = true;
      this.partnerConnectivityTestResultsShow = false;

      try {
        const result = await testPartnerConnectivity(params);
        this.partnerConnectivityTestResults = { ...result.data };
      } catch (e) {
        this.partnerConnectivityTestResults.error_msg = e.message;
      } finally {
        this.partnerConnectivityTestResultsShow = true;
        this.partnerConnectivityTestResultsLoading = false;
      }
    },
    validateEmail(email) {
      if (!email) return true;
      return emailRegex.test(email);
    },

    async editWhitelist(partner) {
      this.currentPartner = partner;
      this.whitelistDialog = true;

      try {
        if (partner.whitelist) {
          this.whitelistForm = { ...partner.whitelist };
        } else {
          this.whitelistForm = {
            partner: '',
            primary_contacts: [],
            allowed_emails: [],
            no_limits: true,
            notes: '',
          };
        }
      } catch (err) {
        console.error(err);
      }
    },
    closeWhitelistDialog() {
      this.whitelistDialog = false;
      this.currentPartner = null;
      this.whitelistForm = {
        partner: '',
        primary_contacts: [],
        allowed_emails: [],
        no_limits: true,
        notes: '',
      };
    },

    async saveWhitelist() {
      if (!this.currentPartner) return;

      if (!this.$refs.whitelistForm.validate()) return;

      this.whitelistSaving = true;
      try {
        const payload = { ...this.whitelistForm };
        let response = null;
        if (this.currentPartner.whitelist) {
          response = await this.updateWhitelistAction({
            id: this.currentPartner.whitelist.id,
            payload,
          });
        } else {
          response = await this.createWhitelistAction({
            ...payload,
            partner: this.currentPartner.id,
          });
        }
        const updatedPartner = {
          ...this.currentPartner,
          whitelist: response,
        };
        await this.editPartnerAction(updatedPartner);

        this.showSnackbar(true, 'Whitelist uspešno shranjen');
        this.closeWhitelistDialog();
      } catch (err) {
        this.showSnackbar(false, 'Napaka pri shranjevanju whiteliste');
      } finally {
        this.whitelistSaving = false;
      }
    },
  },
};
</script>

<style scoped>
.v-text-field {
  padding: 0;
}
::v-deep .v-table__overflow {
  overflow: auto;
  max-height: 70vh;
}
</style>
